import { tabsHandler, grubScrolling, swiperInit } from './helper'

tabsHandler({
  wrapClass: 'lessons__list',
  activeTrigger: 'row-tab__head--active',
  activeTarget: 'row-tab__body-item--active',
  func: (ind) => {
    swiperInit({
      init: false,
      perView: 1,
      className: '.culture-slider--' + ind,
      nextBtnClass: '.culture-slider--' + ind + ' .culture-slider__btn--right',
      prevBtnClass: '.culture-slider--' + ind + ' .culture-slider__btn--left',
      spaceBetween: 0,
      swiperCurrentClass: '.culture-slider--' + ind + ' .culture-slider__counter-ind',
      swiperCountClass: '.culture-slider--' + ind + ' .culture-slider__counter-total',
      loop: false,
    })
  }
})

tabsHandler({
  wrapClass: 'holidays__list',
  activeTrigger: 'row-tab__head--active',
  activeTarget: 'row-tab__body-item--active',
  func: (ind) => {
    swiperInit({
      init: false,
      perView: 1,
      className: '.holidays-slider--' + ind,
      nextBtnClass: '.holidays-slider--' + ind + ' .holidays-slider__btn--right',
      prevBtnClass: '.holidays-slider--' + ind + ' .holidays-slider__btn--left',
      spaceBetween: 0,
      swiperCurrentClass: '.holidays-slider--' + ind + ' .holidays-slider__counter-ind',
      swiperCountClass: '.holidays-slider--' + ind + ' .holidays-slider__counter-total',
      loop: false,
    })
  }
})

swiperInit({
  init: false,
  perView: 1,
  className: '.culture-slider--' + 0,
  nextBtnClass: '.culture-slider--' + 0 + ' .culture-slider__btn--right',
  prevBtnClass: '.culture-slider--' + 0 + ' .culture-slider__btn--left',
  spaceBetween: 0,
  swiperCurrentClass: '.culture-slider--' + 0 + ' .culture-slider__counter-ind',
  swiperCountClass: '.culture-slider--' + 0 + ' .culture-slider__counter-total',
  loop: false,
})

swiperInit({
  init: false,
  perView: 1,
  className: '.holidays-slider--' + 0,
  nextBtnClass: '.holidays-slider--' + 0 + ' .holidays-slider__btn--right',
  prevBtnClass: '.holidays-slider--' + 0 + ' .holidays-slider__btn--left',
  spaceBetween: 0,
  swiperCurrentClass: '.holidays-slider--' + 0 + ' .holidays-slider__counter-ind',
  swiperCountClass: '.holidays-slider--' + 0 + ' .holidays-slider__counter-total',
  loop: false,
})

grubScrolling('.vacancies__tags', {
  left: '.vacancies__head .slide-controls__btn--left',
  right: '.vacancies__head .slide-controls__btn--right'
})

collapseTabs()

function collapseTabs() {
  const items = document.querySelectorAll('.collapse-item')

  items.forEach((e) => {
    e.addEventListener('click', (node) => {
      const eHead = node.target.closest('.collapse-item__head')
      
      if (eHead) {
        e.classList.toggle('active')
        const slideClass = '.' + e.dataset.slideClass

        swiperInit({
          init: false,
          perView: 1,
          className: slideClass,
          nextBtnClass: slideClass + ' .culture-slider__btn--right',
          prevBtnClass: slideClass + ' .culture-slider__btn--left',
          spaceBetween: 0,
          swiperCurrentClass: slideClass + ' .culture-slider__counter-ind',
          swiperCountClass: slideClass + ' .culture-slider__counter-total',
          loop: false,
        })
      }
    })
  })
}